import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { CheckCircle, Mail } from 'lucide-react';
import { Button } from '../components/ui/button';
import Header from '../components/Header';
import Footer from '../components/Footer';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const NAV_ITEMS = [
  { to: '/', label: 'Home' },
  { to: '/daily', label: 'Daily OBX' },
  { to: '/archive', label: 'Archive' },
];

const FOOTER_LINKS = [
  { to: '/about', label: 'About' },
  { to: '/gallery', label: 'Gallery' },
];

function DailyOBXSuccess() {
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const [email, setEmail] = useState('');

  useEffect(() => {
    const sessionId = searchParams.get('session_id');
    if (sessionId) {
      fetchDetails(sessionId);
    } else {
      setLoading(false);
    }
  }, [searchParams]);

  const fetchDetails = async (sessionId) => {
    try {
      const response = await axios.get(`${BACKEND_URL}/api/supporters/status/${sessionId}`);
      if (response.data.customer_email) {
        setEmail(response.data.customer_email);
      }
    } catch (error) {
      console.error('Failed to fetch details');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="substack-site" style={{ background: '#fafafa' }}>
      {/* Header */}
      <Header navItems={NAV_ITEMS} />

      {/* Main Content */}
      <main style={{ 
        maxWidth: '600px', 
        margin: '0 auto', 
        padding: '80px 20px',
        textAlign: 'center'
      }}>
        {loading ? (
          <div className="loading-spinner" />
        ) : (
          <>
            {/* Success Icon */}
            <div style={{
              width: '100px',
              height: '100px',
              borderRadius: '50%',
              background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 30px'
            }}>
              <CheckCircle size={50} color="#fff" />
            </div>

            <h1 style={{
              fontFamily: "'Playfair Display', Georgia, serif",
              fontSize: '2.2rem',
              fontWeight: '400',
              color: '#1a1a1a',
              marginBottom: '20px'
            }}>
              Welcome to Daily OBX!
            </h1>
            
            <p style={{
              fontSize: '1.15rem',
              color: '#555',
              lineHeight: '1.7',
              marginBottom: '35px'
            }}>
              Your mornings are about to get a little more coastal.
              {email && (
                <>
                  <br /><br />
                  Starting tomorrow, you'll receive your first Daily OBX email at <strong>{email}</strong>.
                </>
              )}
            </p>

            <div style={{
              background: '#fff',
              border: '1px solid #e5e5e5',
              borderRadius: '12px',
              padding: '30px',
              marginBottom: '40px',
              textAlign: 'left'
            }}>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                marginBottom: '15px',
                color: '#1a1a1a'
              }}>
                <Mail size={22} />
                <strong>What to expect</strong>
              </div>
              <ul style={{
                margin: 0,
                paddingLeft: '20px',
                color: '#555',
                lineHeight: '1.8'
              }}>
                <li>A fresh photo from the Outer Banks</li>
                <li>A thought from the Beach Bum Code</li>
                <li>A quirky holiday you didn't know existed</li>
                <li>Delivered every morning, before the world gets loud</li>
              </ul>
            </div>

            <p style={{
              fontSize: '1rem',
              color: '#888',
              marginBottom: '30px',
              fontStyle: 'italic'
            }}>
              "Fourteen years. Thousands of mornings. One mostly good stretch of coast."
              <br />— Roy Edlund, The OBX Beach Bum
            </p>

            <div style={{ display: 'flex', gap: '15px', justifyContent: 'center', flexWrap: 'wrap' }}>
              <Link to="/">
                <Button variant="outline">
                  Back to Home
                </Button>
              </Link>
              <Link to="/gallery">
                <Button style={{ background: '#1a1a1a' }}>
                  Browse the Gallery
                </Button>
              </Link>
            </div>
          </>
        )}
      </main>

      {/* Footer */}
      <Footer links={FOOTER_LINKS} />
    </div>
  );
}

export default DailyOBXSuccess;
